export default __webpack_public_path__ + "static/media/4.f25f03c3.png";